/**
 * kimlikNo.js — T.C. / pasaport no için YALNIZCA ön uç uyarısı.
 *
 * Backend hiçbir biçim ya da sağlama kontrolü yapmıyor (yalnızca boş-mu ve mükerrer-mi);
 * TCKN ile pasaport aynı `person_id_number` sütununda duruyor ve tür bilgisi tek başına
 * `person_nationality_id` (1 T.C. / 2 Yabancı). Bu yüzden buradaki kontrol ENGELLEMEZ,
 * yalnızca uyarır: yerel veritabanındaki test kayıtlarının çoğu uydurma TCKN taşıyor ve
 * eski kayıtlar da aynı serbestlikle açılmış.
 */

import i18n from "../../i18n";

const ON_BIR_HANE = /^\d{11}$/;

/** Resmî TCKN algoritması: ilk hane 0 olamaz, 10. ve 11. haneler sağlama haneleridir. */
export function tcknSaglamaGecerli(no) {
  if (!ON_BIR_HANE.test(no) || no[0] === "0") return false;
  const d = no.split("").map(Number);
  const tekler = d[0] + d[2] + d[4] + d[6] + d[8];
  const ciftler = d[1] + d[3] + d[5] + d[7];
  const onuncu = (((tekler * 7 - ciftler) % 10) + 10) % 10;
  const onbirinci = d.slice(0, 10).reduce((a, b) => a + b, 0) % 10;
  return d[9] === onuncu && d[10] === onbirinci;
}

/** 11 haneli sayı → T.C. ("1"), diğer her şey (pasaport) → Yabancı ("2"). Yalnızca ön seçim. */
export function varsayilanUyruk(no) {
  return ON_BIR_HANE.test(String(no ?? "").trim()) ? "1" : "2";
}

/**
 * Yeni kişi formu için yumuşak uyarı metni; sorun yoksa null.
 * @param no       kimlik no (sorgulanan)
 * @param uyrukId  "1" T.C. / "2" Yabancı — kullanıcının formdaki seçimi
 */
export function kimlikUyarisi(no, uyrukId) {
  const temiz = String(no ?? "").trim();
  if (!temiz || String(uyrukId) !== "1") return null;
  if (!ON_BIR_HANE.test(temiz)) {
    return i18n.t("components:kimlikNo.tCUyrukluKisilerdeKimlik");
  }
  if (!tcknSaglamaGecerli(temiz)) {
    return i18n.t("components:kimlikNo.buNumaraGecerliBirT");
  }
  return null;
}
